import "babel-polyfill";
import React from 'react';
import PerspectiveSelectItem from './PerspectiveSelectItem.js';
// import "ie-array-find-polyfill";

class DesignerPerspectiveSelect extends React.Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(pers) {
        this.props.onPerspectiveLayerSelect(pers);
    }

    render() {

        const perspectiveSelects = [];
        for (var persI = 0; persI < this.props.perspectives.length; persI++) {

            const background = this.props.backgrounds.find((bg) => {
                return bg.background_id == this.props.activeBackgroundVariant.id && bg.perspective_id == this.props.perspectives[persI].id
            });

            perspectiveSelects.push(
                <PerspectiveSelectItem
                    key={'pers_select_' + this.props.perspectives[persI].id + this.props.perspectives[persI].varid}
                    perspective={this.props.perspectives[persI]}
                    background={background}
                    active={this.props.perspectives[persI].id == this.props.activePerspective.id}
                    onPerspectiveSelect={this.handleSelect}
                />
            );
        }

        return (
            <div className="designer_preview_perspective_select">
                {perspectiveSelects}
                <div style={{clear: 'left'}} />
            </div>
        );
    }
}
export default DesignerPerspectiveSelect;



// WEBPACK FOOTER //
// ./src/DesignerPerspectiveSelect.js